import React, { Component } from "react";
import {
  Label,
  Grid,
  Table,
  Button,
  Input,
  Dropdown,
  Segment,
  Divider,
} from "semantic-ui-react";
import "./reports.css";
import { app } from "../..";
import moment from "moment";
import { genempdrop } from "../../services/gendropdown";
class LaborReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorter: "workordernumber",
      startdate: null,
      enddate: null,
      empnumber: null,
      report_data: [],
    };
  }
  genReport() {
    if (this.state.startdate && this.state.enddate && this.state.empnumber) {
      app
        .service("reports")
        .find({
          query: {
            report: "labor",
            empnumber: this.state.empnumber,
            startdate: this.state.startdate,
            enddate: this.state.enddate,
            sorter: this.state.sorter,
          },
        })
        .then((res) => {
          console.log("Report Data", res);
          this.setState({ report_data: res });
        });
    }
  }
  genWodReportTable() {
    if (
      this.state.sorter === "workordernumber" &&
      this.state.report_data.length
    ) {
      return (
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Date Performed</Table.HeaderCell>
              <Table.HeaderCell>Hours</Table.HeaderCell>
              <Table.HeaderCell>Rate</Table.HeaderCell>
              <Table.HeaderCell>Tm Number</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {this.state.report_data.map((rd) => {
            return (
              <Table.Body>
                <Table.Row>
                  <Table.Cell colSpan="6">
                    <Label color="red" ribbon>
                      <h4>{rd.wonum}</h4>
                    </Label>
                  </Table.Cell>
                </Table.Row>
                {rd.labor_entries.map((le) => {
                  return (
                    <Table.Row>
                      <Table.Cell>
                        {moment(le.dateperformed).format("MM/DD/YYYY")}
                      </Table.Cell>
                      <Table.Cell>{le.hours}</Table.Cell>
                      <Table.Cell>{le.payrate}</Table.Cell>
                      <Table.Cell>{le.tmnumber}</Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            );
          })}
        </Table>
      );
    }
  }
  genDateReportTable() {
    if (this.state.sorter === "date" && this.state.report_data.length) {
      return (
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Workorder</Table.HeaderCell>
              <Table.HeaderCell>Hours</Table.HeaderCell>
              <Table.HeaderCell>Rate</Table.HeaderCell>
              <Table.HeaderCell>Tm Number</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {this.state.report_data.map((rd) => {
            return (
              <Table.Body>
                <Table.Row>
                  <Table.Cell colSpan="6">
                    <Label color="red" ribbon>
                      <h4>{moment(rd.date).format("MM/DD/YYYY")}</h4>
                    </Label>
                  </Table.Cell>
                </Table.Row>
                {rd.labor_entries.map((le) => {
                  return (
                    <Table.Row>
                      <Table.Cell>{le.workordernumber}</Table.Cell>
                      <Table.Cell>{le.hours}</Table.Cell>
                      <Table.Cell>{le.payrate}</Table.Cell>
                      <Table.Cell>{le.tmnumber}</Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            );
          })}
        </Table>
      );
    }
  }
  render() {
    return (
      <Grid>
        <Grid.Row id="labortitle">
          <Grid.Column width={4}>
            <h5>Start Date</h5>
          </Grid.Column>
          <Grid.Column width={4}>
            <h5>End Date</h5>
          </Grid.Column>
          <Grid.Column width={2}>
            <h5>Organized By:</h5>
          </Grid.Column>
          <Grid.Column>
            <h5>Employee:</h5>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4}>
            <Input
              placeholder="Start Date"
              fluid
              type="date"
              value={this.state.startdate}
              onChange={(e) =>
                this.setState(
                  {
                    startdate: moment(e.target.value).format("YYYY-MM-DD"),
                  },
                  () => this.genReport()
                )
              }
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <Input
              placeholder="End Date"
              fluid
              type="date"
              value={this.state.enddate}
              onChange={(e) =>
                this.setState(
                  {
                    enddate: moment(e.target.value).format("YYYY-MM-DD"),
                  },
                  () => this.genReport()
                )
              }
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <Button.Group>
              <Button
                positive={this.state.sorter === "workordernumber"}
                onClick={() => this.setState({ sorter: "workordernumber" })}
              >
                Workoder
              </Button>
              <Button.Or />
              <Button
                positive={this.state.sorter === "date"}
                onClick={() =>
                  this.setState({ sorter: "date" }, () => this.genReport())
                }
              >
                Date
              </Button>
            </Button.Group>
          </Grid.Column>
          <Grid.Column>
            <Dropdown
              search
              selection
              value={this.state.empnumber}
              options={genempdrop(this.props.employees)}
              onChange={(e, { value }) =>
                this.setState({ empnumber: value }, () => this.genReport())
              }
            />
          </Grid.Column>
        </Grid.Row>
        <Divider />
        <Grid.Row>
          <Grid.Column width={10}>
            {this.genWodReportTable()}
            {this.genDateReportTable()}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default LaborReport;



// WEBPACK FOOTER //
// ./src/components/reports/labor.jsx